<div class="px-3">
  <h2>{{ 'portfolio.title' | translate }}</h2>
  <div class="portfolio-grid-shell">
    <gstar-prime-grid
      #grid
      [source]="securities().items"
      [totalRows]="securities().total"
      sessionKey="portfolio"
      [isLoading]="isLoading()"
      [headers]="headers()"
      [settings]="setting"
      (queryChange)="queryHandler($event)"
      (selectRows)="onSecuritySelected($event)"
      (clearAll)="clearFilters()">
      <ng-container start-toolbar>
        <gstar-transaction-type-dropdown
          gstarDropDownAppkitOverlayListFix
          [transactionType]="transactionType"
          (updateTransactionType)="selectTransactionType($event)" />
      </ng-container>
      <ng-container end-toolbar>
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex justify-content-end mb-3">
            <ap-button
              class="mt-4"
              btnType="primary"
              [label]="'portfolio.generalRates' | translate"
              (onClick)="addSecurities(enumTransactionTypeItems.GeneralRates)"
              icon="plus-outline" />
            <ap-button
              class="mt-4 px-3"
              btnType="primary"
              [label]="'portfolio.specificAdvice' | translate"
              (onClick)="addSecurities(enumTransactionTypeItems.SpecificAdvice)"
              icon="plus-outline" />
            <ap-button
              class="mt-4"
              btnType="primary"
              [label]="'portfolio.import.buttonLabel' | translate"
              [loading]="importLoading()"
              [isLoading]="importLoading()"
              [disabled]="!hasClientSelected()"
              (onClick)="importFile()"
              ap-tooltip
              [tooltipContent]="importLoading() ? tooltip : null"
              direction="top"
              icon="upload-outline" />
            <ng-template #tooltip>
              <div>{{ 'notifications.fileProcessing' | translate }}</div>
            </ng-template>
            <ap-button
              class="mt-4 px-3"
              btnType="primary"
              [label]="'portfolio.exportToExcel.buttonLabel' | translate"
              [disabled]="
                !hasClientSelected() || securitiesSelected().length === 0
              "
              (onClick)="exportExcel()"
              icon="download-outline" />
          </div>
        </div>
      </ng-container>
    </gstar-prime-grid>
  </div>
</div>
